module.exports = __webpack_public_path__ + "static/img/NowPlaying@2x.acdb615.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/2x/NowPlaying@2x.png
// module id = CII9
// module chunks = 1